class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const faqItems = this.querySelectorAll('[data-faq-item]');
    
    faqItems.forEach(item => {
      const summary = item.querySelector('summary');
      
      summary.addEventListener('click', (e) => {
        // Close other items if needed (optional - remove if you want multiple open)
        // faqItems.forEach(otherItem => {
        //   if (otherItem !== item && otherItem.hasAttribute('open')) {
        //     otherItem.removeAttribute('open');
        //   }
        // });
      });
    });
  }
}

if (!customElements.get('faq-section')) {
  customElements.define('faq-section', FAQSection);
}

